'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOrderDetail = undefined;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TalarisAPI = {
  alpha: '//talaris-team-ws.alpha.elenet.me:8070/talaris-svr',
  alta: '//talaris-team-ws.alta.elenet.me/talaris-svr',
  altb: '//talaris-team-ws.altb.elenet.me/talaris-svr',
  ar: '//talaris-team-ws.ar.elenet.me/talaris-svr',
  prod: '//app2-edu.ele.me/talaris-svr'
};

var env = 'ar';
var url = window.location.href;

switch (true) {
  case url.indexOf('alpha.') > 0:
    env = 'alpha';
    break;
  case url.indexOf('alta.') > 0:
    env = 'alta';
    break;
  case url.indexOf('altb.') > 0:
    env = 'altb';
    break;
  case url.indexOf('localhost') > 0:
  case url.indexOf('ar.') > 0:
    env = 'ar';
    break;
  default:
    env = 'prod';
}

/**
 * fetch Order Detail
 * @param { String } trackingId
 * @return { Promise }
 */
var fetchOrderDetail = exports.fetchOrderDetail = function fetchOrderDetail(orderId) {
  return _axios2.default.get(TalarisAPI[env] + '/webapi/web/dispatch/shippingorder/order/' + orderId, {
    withCredentials: true
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/@ele/lpd-component/lib/components/order-dialog/src/api/api.js
// module id = 298
// module chunks = 0